import type { User as SentryUser } from '@sentry/sveltekit'
import { decodeJwtPayload } from '#lib/jwt.js'
import { botJwtSchema, type User } from '#lib/types/luka-api/auth/index.js'

/** Who a replay or error belongs to: the logged-in user, else the bot session's chat. */
export function sentryUser(user: User | null, botToken: string | null): SentryUser | null {
	if (user != null) {
		return user.email == null ? { id: String(user.id) } : { id: String(user.id), email: user.email }
	}

	if (botToken == null) return null

	const decoded = botJwtSchema.safeParse(decodeJwtPayload(botToken))

	return decoded.success ? { id: `chat:${decoded.data.principal.chatId}` } : null
}
